
import { Options, Vue } from 'vue-class-component'
import AdminWeb from './components/AdminWeb.vue'

@Options({
  components: {
    AdminWeb
  }
})
export default class App extends Vue {}
